import { parsePhoneNumber } from "libphonenumber-js";
import { ContactApi, FindAllContactWithFilterIRoute } from "../api/Contacts";
import { IContact } from "../types/Contact";
import { ITag } from "../types/TagTypes";

type ICsvFromContact =
  | {
      query: FindAllContactWithFilterIRoute;
    }
  | {
      contacts: IContact[];
      selectedContacts?: string[];
    };

type IGenerateCsv = {
  tags: ITag[];
} & ICsvFromContact;

export async function generateCSV(props: IGenerateCsv) {
  let fullContactSelected: IContact[] = [];
  let contactCSV = [
    [
      "id",
      "email",
      "first name",
      "last name",
      "phone",
      "country",
      "status",
      "tags",
      "date created",
    ],
  ];

  if ("query" in props) {
    const query = { ...props.query };

    // Delete any params used for sorting, as this might fuck up the
    // MongoDB query (exceeding limit on sort)

    delete query.email;
    delete query.name;
    delete query.name;
    delete query.phone;
    delete query.statusOrder;
    delete query.createdAt;

    fullContactSelected = (await ContactApi.read(query)).contacts;
  } else if ("selectedContacts" in props) {
    fullContactSelected = props.selectedContacts.map((sc) =>
      props.contacts.find((c) => c._id === sc)
    ) as IContact[];
  } else {
    fullContactSelected = props.contacts;
  }

  let selectedContactsWithTags = fullContactSelected.map((c) => ({
    ...c,
    tags: c.tags
      .map((tId) => props.tags.find((t) => t._id === tId._id))
      .filter((t) => t),
  }));

  selectedContactsWithTags
    .filter((c) => c)
    .forEach((contact) => {
      if (!contact) return;

      let country = "";

      if (contact.phone) {
        try {
          contact.phone = `+${contact.phone}`;
          const phoneNumber = parsePhoneNumber(contact.phone);
          country = phoneNumber?.country || "";
        } catch (e) {
          country = "";
        }
      }

      contactCSV.push([
        `${contact._id}`,
        `${contact.email}`,
        `${contact.firstName || ""}`,
        `${contact.lastName || ""}`,
        `${contact.phone || ""}`,
        `${country}`,
        `${contact.status}`,
        `"${contact.tags
          .map((m) => m?.name)
          .filter((x) => x)
          .join(", ")}"`,
        `"${contact.createdAt}"`,
      ]);
    });

  let csv = contactCSV.map((l) => l.join(",")).join("\n");
  return csv;
}

/**
 * This is not working, debug
 */
// expose({
//   generateCSV,
// });
